<template>
  <div></div>
</template>

<script>
import { createSlider } from "@typeform/embed";
import { mapActions, mapGetters } from "vuex";
import "@typeform/embed/build/css/slider.css";

export default {
  name: "BaseScoreDialog",
  data() {
    return {
      slider: undefined,
      currentScore: 0,
      scoring: false,
      focuses: [],
      programId: null,
    };
  },

  computed: {
    ...mapGetters("scores", ["scores"]),
    ...mapGetters("forms", ["focusFormResponses"]),
    ...mapGetters("users", ["getEmail", "user"]),
  },

  watch: {
    scores(newVal) {
      if (!this.scoring) this.create();
    },
  },
  async mounted() {
    await this.startPolling({ apolloClient: this.$apollo });
  },

  methods: {
    ...mapActions("scores", ["startPolling"]),
    ...mapActions("forms", ["getFocusFormResponses"]),
    ...mapActions("schedules", ["fetchCoacheeSessions"]),
    open(score) {
      if (score._id && score.path) {
        console.log("score", score);
        const hidden = {
          score_id: score._id,
          environment: process.env.NODE_ENV,
          env: process.env.NODE_ENV,
          email: this.getEmail,
          program_id: this.programId,
        };
        console.log("hidden", hidden);
        if (this.focuses.length) {
          for (let i = 0; i < this.focuses.length; i++) {
            hidden[`focus_${i + 1}`] = this.focuses[i];
          }
        }
        const slider = createSlider(score.path, {
          autoresize: true,
          autoClose: 1000,
          onSubmit: this.close,
          onClose: this.close,
          hidden,
          position: "left",
        });
        this.slider = slider;
        slider.open();
      }
    },

    async getProgramId() {
      try {
        // Coachee: Has programs ids, use the last one
        if (this.user?.programs?.length) {
          return this.user.programs[this.user.programs.length - 1]._id;
        } 
        
        // Coach: Has no programs ids, use score.reference -> get session -> session.program
        const session = await this.fetchSessionById(this.scores[0].reference);
        if (!session) return null;
        
        return session[0]?.program?._id;
      } catch(error) {
        console.error("Error fetching program ID:", error);
        return null;
      }
    },

    async fetchSessionById(id) {
      try {
        const session = await this.fetchCoacheeSessions({
          apolloClient: this.$apollo,
          data: {
            filter: {
              _id: id,
            },
          },
        });
        return session;
      } catch (error) {
        console.error(`Error fetching session with ID ${id}:`, error);
        return null;
      }
    },

    async create() {
      try {
        if (!this.scores.length) return;
        this.programId = await this.getProgramId();

        if (this.programId) {
          await this.getFocusFormResponses({
            apolloClient: this.$apollo,
            programId: this.programId,
            userId: this.user._id,
          });
          
          if (this.focusFormResponses.length) {
            this.focuses = this.focusFormResponses.map((focus) =>
              focus.label.replace(/[^\w\s]/gi, "")
            );
          }
        };
        this.currentScore = 0;
        this.scoring = true;
        this.open(this.scores[this.currentScore]);
      } catch (error) {
        console.error(error);
      }
    },

    async close() {
      this.currentScore++;
      if (this.scores[this.currentScore]) this.open(this.scores[this.currentScore]);
      else this.scoring = false;
    },
  },
};
</script>

<style lang="scss" scoped></style>
